var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slider-built-cottages__item home-item" }, [
    _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
      _c("div", { staticClass: "cottages__images-img" }, [
        _c(
          "a",
          { attrs: { href: _vm.item.DETAIL_PAGE_URL } },
          [
            _c("slider-photo", {
              attrs: {
                item: _vm.item,
                "max-height": 174,
                "is-playing": _vm.isPlaying,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "built-cottage__content-wrapper" }, [
        _c("div", { staticClass: "built-cottage__content" }, [
          _c("p", { staticClass: "built-cottage__content-title" }, [
            _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
              _vm._v(_vm._s(_vm.item.NAME)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__content-teg" }, [
            _c("img", {
              attrs: { src: _vm.getPath("icon-map.svg"), alt: "Icon" },
            }),
            _vm._v(" "),
            _vm.item.JK
              ? _c(
                  "a",
                  { staticClass: "built-cottage__gk", attrs: { href: "" } },
                  [_vm._v("  " + _vm._s(_vm.item.JK) + " ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.checkPrice(_vm.item)
            ? _c("p", { staticClass: "built-cottage__price" }, [
                _vm._v(
                  "от " +
                    _vm._s(
                      _vm._f("currency")(
                        parseInt(_vm.item.PROPS.PRICE[0].VALUE)
                      )
                    )
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "built-cottage__details" }, [
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Спальни:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.ROOMS[0].VALUE)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Этажей:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.FLOORS[0].VALUE)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Площадь:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.M2[0].VALUE) + " м²"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Участок:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.AREA_M2)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "built-cottage__info" }, [
        _vm.item.PROPS.SPECIAL && _vm.item.PROPS.SPECIAL[0].VALUE
          ? _c("p", { staticClass: "discount-badge" }, [
              _vm._v(_vm._s(_vm.item.PROPS.SPECIAL[0].VALUE_TEXT)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "house-icons" }, [
          _c(
            "button",
            {
              staticClass: "house-icon__btn",
              class: { active: _vm.item.FAVORITE },
              on: {
                click: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k(
                      $event.keyCode,
                      "default",
                      undefined,
                      $event.key,
                      undefined
                    )
                  )
                    return null
                  $event.preventDefault()
                  return _vm.toggleFavorite(_vm.item)
                },
              },
            },
            [
              _c("img", {
                staticClass: "house-icon__img house-icon__img-add",
                attrs: { src: _vm.getPath("icon-heart.svg"), alt: "Icon" },
              }),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }